import { Skeleton } from "@/core/components/ui/skeleton";
import { Typography } from "@/core/components/ui/typography";

interface InfoPairProps {
  label: string;
  value?: string;
  isLoading?: boolean;
}

export const InfoPair = ({ label, value, isLoading }: InfoPairProps) => {
  if (isLoading) {
    return (
      <Typography className="flex items-center gap-1">
        {label}: <Skeleton className="h-4 w-6" variant="inline" />
      </Typography>
    );
  }

  return (
    <Typography>
      {label}: {value && <span className="font-semibold">{value}</span>}
    </Typography>
  );
};
